import { cn } from '#/lib/utils';

export function Background({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 1376 738"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className={cn(`w-full h-full blur-sm`, className)}
    >
      <g filter="url(#filter0_n_11_3326)">
        <rect
          x="-65.5"
          y="-26"
          width="1521"
          height="858"
          fill="url(#paint0_linear_11_3326)"
        />
      </g>
      <defs>
        <filter
          id="filter0_n_11_3326"
          x="-65.5"
          y="-26"
          width="1521"
          height="858"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="2 2"
            stitchTiles="stitch"
            numOctaves="3"
            result="noise"
            seed="7522"
          />
          <feComponentTransfer in="noise" result="coloredNoise1">
            <feFuncR type="linear" slope="2" intercept="-0.5" />
            <feFuncG type="linear" slope="2" intercept="-0.5" />
            <feFuncB type="linear" slope="2" intercept="-0.5" />
            <feFuncA
              type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="shape"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feComponentTransfer in="noise1Clipped" result="color1">
            <feFuncA type="table" tableValues="0 0.15" />
          </feComponentTransfer>
          <feMerge result="effect1_noise_11_3326">
            <feMergeNode in="shape" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <linearGradient
          id="paint0_linear_11_3326"
          x1="695"
          y1="193"
          x2="695"
          y2="832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DFDEFD" />
          <stop offset="0.331731" stopColor="#DFDEFD" />
          <stop offset="0.894231" stopColor="#7F7CF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
